<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

    export let title = ""
    export let display = function(v: any) { return v }
    export let value = 0
    export let min = 0
    export let values: null | any[] = null
    export let max = values ? (values.length-1) : 100
    export let step = 1
    export let id = "slider"
    export let interval = 50

    export function getValue(): any {
        if (values == null) {
            return null
        }
        return values[parseInt(rangeControl.value)]
    }

    let rangeControl: HTMLInputElement

    let timer_id: number | null = null
    function fire_timeout() {
        dispatch('settled', {"value": values ? values[value] : value})
    }

    function wait_settle(ev: Event) {
        if (timer_id != null) {
            clearTimeout(timer_id)
        }
        if (interval == 0) {
            fire_timeout()
        } else {
            setTimeout(fire_timeout, interval)
        }
    }

</script>
<style>
   /*Full width sliders*/
    input[type=range]{
        width: 100%;
    }
</style>

<label style="display: block;" for="{id}">{title}</label>
<input bind:this={rangeControl} id="{id}" type="range" min="{min}" max="{max}" step="{step}"
    bind:value={value}
    on:change={wait_settle}
    on:mousedown
    on:mouseup
    />
<span>{display(values ? values[value] : value)}</span>